import fetch from "auth/FetchInterceptor";

const TopAgenciesService = {};

TopAgenciesService.index = function (payload) {
  return fetch({
    url:
      "/reports/topagencies?" +
      "startdate=" +
      payload.startDate +
      "&enddate=" +
      payload.endDate +
      "&agency=" +
      payload.agency +
      "&department=" +
      payload.department,
    method: "get",
  });
};

export default TopAgenciesService;
